export default __webpack_public_path__ + "static/media/statusCanceled.1a15ead2.png";